import React, { useEffect, useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllPartners } from "../../../store/cabinet/action";

const formatUsd = (value) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "$0";

    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: numberValue % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(numberValue);
};

const formatPoints = (value) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "0";

    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(numberValue);
};

const CabinetPartnersList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const partnersAll = useSelector(store => store.cabinet.partnersAll);
    const partnersAllStarted = useSelector(store => store.cabinet.partnersAllStarted);

    const [incomeFilter, setIncomeFilter] = useState("all");

    const partnersList = useMemo(() => {
        return partnersAll?.items || [];
    }, [partnersAll]);

    useEffect(() => {
        dispatch(getAllPartners());
    }, [dispatch]);

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.topRow}>
                    <div className={Styles.title}>
                        {t("Ваши рефералы")}
                    </div>

                    <div className={Styles.filtersWrap}>
                        <div className={Styles.selectWrap}>
                            <select
                                value={incomeFilter}
                                onChange={(e) => setIncomeFilter(e.target.value)}
                            >
                                <option value="all">
                                    {t("Все")}
                                </option>

                                <option value="deposits">
                                    {t("С депозитов")}
                                </option>

                                <option value="referral_income">
                                    {t("С реферального дохода")}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className={Styles.tableScroll}>
                    <div className={Styles.tableInner}>
                        <div className={Styles.tableHead}>
                            <div>{t("Имя")}</div>
                            <div>{t("Уровень")}</div>
                            <div>{t("Сумма депозита")}</div>
                            <div>{t("Ваши поинты")}</div>
                        </div>

                        {partnersAllStarted ? (
                            <div className={Styles.emptyText}>
                                {t("Загрузка")}
                            </div>
                        ) : partnersList.length > 0 ? (
                            partnersList.map((partner, index) => (
                                <div
                                    className={Styles.tableRow}
                                    key={`${partner.email}-${index}`}
                                >
                                    <div className={Styles.nameCol}>
                                        <span className={Styles.mobileLabel}>
                                            {t("Имя")}
                                        </span>

                                        <span className={Styles.nameValue}>
                                            {partner.email || "—"}
                                        </span>
                                    </div>

                                    <div className={Styles.levelCol}>
                                        <span className={Styles.mobileLabel}>
                                            {t("Уровень")}
                                        </span>

                                        <span className={Styles.cellValue}>
                                            {partner.level ?? "—"}
                                        </span>
                                    </div>

                                    <div className={Styles.depositCol}>
                                        <span className={Styles.mobileLabel}>
                                            {t("Сумма депозита")}
                                        </span>

                                        <span className={Styles.depositValue}>
                                            {formatUsd(partner.deposit_amount)}
                                        </span>
                                    </div>

                                    <div className={Styles.pointsCol}>
                                        <span className={Styles.mobileLabel}>
                                            {t("Ваши поинты")}
                                        </span>

                                        <span className={Styles.pointsValue}>
                                            {formatPoints(partner.points)}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={Styles.emptyText}>
                                {t("Рефералы пока не найдены")}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CabinetPartnersList;